const WatermarkOverlay = ({ user }) => {
  if (!user?.Email) return null;

  const watermarkText = `
    ${user.Email}
    User ID: ${user.Id}
    ${new Date().toISOString()}
  `;

  return (
    <div className="watermark-overlay">
      {[...Array(20)].map((_, i) => (
        <span key={i} className="watermark-text">
          {watermarkText}
        </span>
      ))}
    </div>
  );
};

export default WatermarkOverlay;
